import React from 'react';
//import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import { cognitoUserPoolId, cognitoUserPoolClientId, restApiEndpoint, restApiName } from './config';

import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from '@aws-amplify/auth';



import { createRoot } from 'react-dom/client';

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: cognitoUserPoolId,
            userPoolClientId: cognitoUserPoolClientId,
            userPoolWebClientId: cognitoUserPoolClientId,
        }
    },
    API: {
        REST: {
            [restApiName]: {
                endpoint: restApiEndpoint
            }
        }
    }
}, {
    API: {
        REST: {
            headers: async ({ apiName }) => {
                if (apiName === restApiName) {
                    const session = await fetchAuthSession();
                    return {
                        Authorization: `Bearer ${session.tokens?.idToken?.toString()}`,
                    };
                } else {
                    return { };
                }

            }
        }
    }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);
